var _rect, _rect2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPointAcomponent = function SvgPointAcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2.083,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#70D6BA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2.083,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#E2F7F1",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13.583,
    r: 2,
    fill: "#FFF"
  })));
};
export default SvgPointAcomponent;